import { Tabs, TabsProps } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import "./MergeDuplicateBrandPage.css";
import { useAppDispatch } from "../../redux/useAppDispatch";
import Search from "antd/es/input/Search";
import DuplicatesTabComponent from "../../components/MergeDuplicateBrandComponent/DuplicatesTabComponent/DuplicatesTabComponent";
import MergeRequestTabComponent from "../../components/MergeDuplicateBrandComponent/MergeRequestTabComponent/MergeRequestTabComponent";
import {
  fetchDuplicateBrand,
  fetchMergeRequestBrandList,
  resetDuplicateBrandTable,
  resetMergeRequestBrandTable,
  updateDuplicateBrandRequestBody,
  updateMergeRequestBrandListRequestBody,
} from "../../redux/LivePlatform/LivePlatformAction";

function MergeDuplicateBrandPage(props: any) {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const [key, setKey] = useState(() => searchParams.get("tab") || "0");

  const [duplicateSearch, setDuplicateSearch] = useState("");
  const [mergeRequestSearch, setMergeRequestSearch] = useState("");

const onTabChange = (newKey: string) => {
  setKey(newKey);
  const params = new URLSearchParams(location.search);
  params.set("tab", newKey);
  navigate({ pathname: location.pathname, search: params.toString() });
};

  useEffect(() => {
    dispatch(fetchDuplicateBrand({}));
    dispatch(fetchMergeRequestBrandList({}));
    return () => {
      dispatch(resetDuplicateBrandTable());
      dispatch(resetMergeRequestBrandTable());
    };
  }, []);
  const onDuplicateBrandSearch = (searchValue: string) => {
    dispatch(resetDuplicateBrandTable());
    dispatch(updateDuplicateBrandRequestBody({ Keyword: searchValue }));
    dispatch(fetchDuplicateBrand({}));
  };
  const onMergeRequestSearch = (searchValue: string) => {
    dispatch(resetMergeRequestBrandTable());
    dispatch(updateMergeRequestBrandListRequestBody({ Keyword: searchValue }));
    dispatch(fetchMergeRequestBrandList({}));
  };
  const items: TabsProps["items"] = [
    {
      key: "0",
      label: "Duplicates",
      children: <DuplicatesTabComponent onTabChange={onTabChange} />,
    },
    {
      key: "1",
      label: "Merge Requests",
      children: <MergeRequestTabComponent />,
    },
  ];

  return (
    <div className="body-container pt-3 h-100 gap-3 merge-duplicate-tabs">
      <div className="h-100 position-relative overflow-hidden">
        <Tabs
          defaultActiveKey="0"
          type="card"
          onChange={(key) => onTabChange(key)}
          activeKey={key}
          tabBarExtraContent={
            <div className="search-bar">
              {key === "0" ? (
                <Search
                  type="text"
                  size="large"
                  allowClear
                  value={duplicateSearch}
                  placeholder="Search by Website"
                  onSearch={onDuplicateBrandSearch}
                  onChange={(e) => setDuplicateSearch(e.target.value)}
                />
              ) : (
                <Search
                  type="text"
                  size="large"
                  allowClear
                  value={mergeRequestSearch}
                  placeholder="Search by all"
                  onSearch={onMergeRequestSearch}
                  onChange={(e) => setMergeRequestSearch(e.target.value)}
                />
              )}
            </div>
          }
          items={items}
          style={{ height: "100%" }}
        />
      </div>
    </div>
  );
}
export default MergeDuplicateBrandPage;
